import { Select as MantineSelect, type SelectProps } from "@mantine/core";
import { useMemo } from "react";
import {
  normalizeSelectData,
  normalizeSelectValue,
} from "src/utils/mantineComboboxData";

export type { SelectProps };

function Select({ data, value, ...props }: SelectProps) {
  const normalizedData = useMemo(
    () => (data ? normalizeSelectData(data) : data),
    [data],
  );

  const normalizedValue =
    value !== undefined ? normalizeSelectValue(value) : value;

  return (
    <MantineSelect {...props} data={normalizedData} value={normalizedValue} />
  );
}

export default Select;
